import React from 'react';
const AddMember = (props) => {
    const attribute = Object.assign({}, props);
    const stroke = attribute.stroke || '#262A33';
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M8 3L8 13", stroke: stroke, strokeOpacity: "0.9" }),
        React.createElement("path", { d: "M13 8H3", stroke: stroke, strokeOpacity: "0.9" })));
};
export default AddMember;
